// extracted by mini-css-extract-plugin
export default {"form":"Ld","inline":"Md","inputWrapper":"Nd","input":"Od","withoutLabel":"Pd","error":"Qd","label":"Rd"};